import { __rest, __assign } from '../../../../node_modules/tslib/tslib.es6.js';
import React, { useContext } from 'react';
import { FCTheme } from '../../../theming/FCTheme.js';
import { DropdownButtonWrapper, MenuDivider } from './style.js';
import { DropdownMenuProvider } from './DropdownMenuContext.js';
import MenuItem from './MenuItem.js';
import { DropdownMenu } from './DropdownMenu.js';
import DropdownButtonButton from './DropdownButtonButton.js';
import DropdownButtonChildren from './DropdownButtonChildren.js';

var DropdownButton = function DropdownButton(_a) {
  var primary = _a.primary,
      label = _a.label,
      fcStyle = _a.fcStyle,
      children = _a.children,
      buttonColor = _a.buttonColor,
      as = _a.as,
      id = _a.id,
      _b = _a.placement,
      placement = _b === void 0 ? 'bottom-start' : _b,
      rest = __rest(_a, ["primary", "label", "fcStyle", "children", "buttonColor", "as", "id", "placement"]);

  var theme = useContext(FCTheme);
  var state = {
    menuOpen: false,
    menuVisible: false,
    theme: theme,
    as: as,
    id: id,
    menuRef: null,
    selectedItemIndex: 0,
    activeDescendant: id + "_menuitem_0",
    placement: placement
  };
  return /*#__PURE__*/React.createElement(DropdownButtonWrapper, {
    renderAs: as
  }, /*#__PURE__*/React.createElement(DropdownMenuProvider, {
    state: state
  }, /*#__PURE__*/React.createElement(DropdownButtonButton, __assign({
    buttonColor: buttonColor,
    label: label,
    primary: primary,
    fcStyle: fcStyle
  }, rest)), /*#__PURE__*/React.createElement(DropdownButtonChildren, null, children)));
};

var MenuDividerComponent = function MenuDividerComponent() {
  return /*#__PURE__*/React.createElement("li", {
    "aria-hidden": true,
    role: "presentation"
  }, /*#__PURE__*/React.createElement(MenuDivider, null));
};

DropdownButton.Menu = DropdownMenu;
DropdownButton.MenuItem = MenuItem;
DropdownButton.Divider = MenuDividerComponent;
export default DropdownButton;
export { DropdownButton };